export const FETCH_ORGANISATIONS = 'dashboard/FETCH_ORGANISATIONS';
export const FETCH_ORGANISATION_TYPES = 'dashboard/FETCH_ORGANISATION_TYPES';
export const FETCH_CURRENT_USER = 'dashboard/FETCH_CURRENT_USER';
export const EDIT_USER_DETAILS = 'dashboard/EDIT_USER_DETAILS';
export const STORE_RESTORE_ID = 'dashboard/STORE_RESTORE_ID';
export const SETUP_GOOGLE2FA = 'dashboard/SETUP_GOOGLE2FA';
export const FETCH_CURRENCIES = 'fund/FETCH_CURRENCIES';
